/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Error_Go_OfflineInputs */



/**
* | output |
* | --- |
* | "Failed to go offline" |
*
* @param {Offline_Error_Go_OfflineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_error_go_offline = /** @type {((inputs?: Offline_Error_Go_OfflineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Error_Go_OfflineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du passage hors ligne")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al pasar a modo sin conexión")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao ficar offline")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile passare offline")
	return /** @type {LocalizedString} */ ("Failed to go offline")
});